/**
 * 图表option构建工具
 * 常用option:
 * ---------------------------------------
 * yAxis.breaks: 将轴进行中断显示,可用于值相差较大的情况, 依赖: modules/broken-axis
 */
import Utility from './utility';

class ChartOptionBuilder {
  option = {
    chart: { animation: false, colorCount: 20 },
    credits: { enabled: false },
    colors: ['#824880', '#006e54', '#e6b422', '#96514d', '#bf242a', '#17184b', '#6e7955', '#1f3134', '#2c4f54', '#c8c2c6', '#333631', '#cd8c5c', '#715c1f', '#4f455c', '#eb6ea5', '#513743', '#d4dcd6', '#84a2d4', '#c3d825', '#ffea00'],
    title: { text: '' },
    yAxis: { title: { text: null }, gridLineWidth: 0, tickWidth: 1, tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066' },
    xAxis: { tickColor: '#00000066', tickLength: 5, tickWidth: 1, lineWidth: 1, lineColor: '#00000066', labels: { style: { textOverflow: 'none', whiteSpace: 'nowrap' } } },
    plotOptions: { series: { stickyTracking: false, turboThreshold: 0 } }
  };
  type = null;
  data = null;
  config = null;
  constructor(type, data, config = {}) {
    this.type = type;
    this.data = data;
    this.config = config;
    return this;
  }
  get () {
    this[this.type]();
    return this.option;
  }
  /**
   * 饼图
   * 参数：
   *    title   是否有标题行   true
   *    name    名称列        0
   *    y       y轴          1
   * --------------------------------
   * SubLocation	Seqs_Num
   * Mitochondrial	16
   * --------------------------------
   */
  Pie () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.name == null ? 0 : this.config.name,
      p3 = this.config.y == null ? 1 : this.config.y;
    let rows = p1 ? this.data.slice(1) : this.data;
    let sd = []; // series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd.push({ name: r[p2], y: Number(r[p3]), _sn: i })
    }
    let ret = {
      chart: { type: 'pie' },
      plotOptions: { pie: { showInLegend: true }, series: { dataLabels: { enabled: false, format: '{point.name}: {point.y:.2f}' } } },
      tooltip: { headerFormat: '{point.key}：', pointFormat: '{point.y:.2f}' },
      legend: { labelFormat: '{name}: {y:.2f}' },
      series: [{ data: sd }]
    }
    Utility.deepMerge(this.option, ret);
  }
  Pie_Metabolite () {
    this.Pie()
    let ret = {
      plotOptions: { series: { dataLabels: { format: '{point.name}: {point.y}' } } },
      tooltip: { pointFormat: '{point.y}' },
      legend: { labelFormat: '{name}: {y}' },
    }
    Utility.deepMerge(this.option, ret);
  }
  Pie_Protein () {
    this.Pie()
    let ret = {
      plotOptions: { series: { dataLabels: { format: '{point.name}: {point.y}' } } },
      tooltip: { pointFormat: '{point.y}' },
      legend: { labelFormat: '{name}: {y}' },
    }
    Utility.deepMerge(this.option, ret);
  }
  Pie_3D () { this.Pie() }
  /**
   * Venn图
   * --------------------------------
   * list1    list2    list3
   * v10      v20       v30
   * v11      v21       v31
   * --------------------------------
   * {series:[
   *   {name:'list1',data:['v10','v11']},
   *   {name:'list2',data:['v20','v21']},
   *   {name:'list3',data:['v30','v31']},
   * ]}
   */
  Venn () {
    let hs = this.data[0];
    let len = hs.length, ss = [];
    for (let i = 0; i < len; i++) ss.push({ name: hs[i], data: [] })
    for (let i = 1, l = this.data.length; i < l; i++) {
      let r = this.data[i];
      for (let m = 0; m < len; m++) {
        if (r[m]) ss[m].data.push(r[m])
      }
    }
    this.option = { series: ss };
  }

  /**
   * 散点图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    x       x轴          2
   *    y       y轴          3
   *    z       z轴          4
   * --------------------------------
   * group    name    x    y    z
   * xx       xx      12   12   12
   * --------------------------------
   */
  Scatter () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.x == null ? 2 : this.config.x,
      p5 = this.config.y == null ? 3 : this.config.y,
      p6 = this.config.z == null ? 4 : this.config.z;
    let rows = p1 ? this.data.slice(1) : this.data;
    let ser = []; // series
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ser.find(t => t.name == r[p2]);
      else sd = ser[0];
      let xv = Number(r[p4]), yv = Number(r[p5]);
      let sdr = { x: xv, y: yv };
      if (p3 != -1) sdr.name = r[p3];
      if (p6 != -1) sdr.z = r[p6];
      if (sd) {
        sd.data.push(sdr);
      } else {
        let serd = { data: [sdr] };
        if (p2 != -1) serd.name = r[p2];
        ser.push(serd);
      }
    }
    let ret = {
      chart: { type: 'scatter' },
      legend: { enabled: false },
      plotOptions: { series: { stickyTracking: false, dataLabels: { enabled: false, formatter: function () { return this.point.name } } } },
      tooltip: { headerFormat: '', pointFormat: p6 != -1 ? '{point.x:.2f}, {point.y:.2f}, {point.z:.2f}' : '{point.x:.2f}, {point.y:.2f}' },
      series: ser
    }
    Utility.deepMerge(this.option, ret);
  }
  Scatter_Volcano () { this.Scatter() }
  Scatter_PLS () { this.Scatter() }
  Scatter_OPLS () { this.Scatter() }
  Scatter_PCA () { this.Scatter() }

  /**
   * 柏拉图
   * 参数：
   *    title   是否有标题行   true
   *    name    名称列        0
   *    y       y轴          1
   *    topX    前x行         null
   * --------------------------------
   * name    value
   * xx       123
   * --------------------------------
   */
  Pareto () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.name == null ? 0 : this.config.name,
      p3 = this.config.y == null ? 1 : this.config.y,
      p4 = this.config.topX;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p4) rows = rows.slice(0, p4);
    let cs = [], sd = []; //xAxis.categories, series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      cs.push(r[p2]);
      sd.push(Number(r[p3]));
    }
    let ret = {
      xAxis: { categories: cs },
      legend: { enabled: false },
      yAxis: [
        { title: { text: '' }, gridLineWidth: 0, tickWidth: 1, tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066' },
        { title: { text: '' }, gridLineWidth: 0, tickWidth: 1, tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066', max: 100, min: 0, opposite: true, labels: { format: '{value}%' } }
      ],
      series: [
        { type: 'column', data: sd, tooltip: { headerFormat: '', pointFormat: '{point.category}: {point.y:.2f}' } },
        { type: 'pareto', yAxis: 1, baseSeries: 0, tooltip: { headerFormat: '', pointFormat: '{point.category}: {point.y:.2f}%' } }
      ]
    }
    delete this.option.yAxis;
    Utility.deepMerge(this.option, ret);
  }


  /**
   * 网络图（力导图）
   * 参数：
   *    title   是否有标题行   true
   *    from    from列        0
   *    to      to列          1
   * --------------------------------
   * from    to
   * xx      xx
   * --------------------------------
   */
  Networkgraph () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.from == null ? 0 : this.config.from,
      p3 = this.config.to == null ? 1 : this.config.to;
    let rows = p1 ? this.data.slice(1) : this.data;
    let sd = []; // series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd.push([r[p2], r[p3]]);
    }
    let ret = {
      chart: { type: 'networkgraph' },
      plotOptions: { networkgraph: { dataLabels: { enabled: true }, layoutAlgorithm: { enableSimulation: true, maxIterations: 28 } } },
      series: [{ data: sd }]
    }
    Utility.deepMerge(this.option, ret);
  }
  Networkgraph_Protein () { this.Networkgraph() }

  /**
   * 折线图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    y       y轴          2
   *    order   排序方式      0      (按y轴排序: 0:不排序,1:升序,-1:降序)
   * --------------------------------
   * group     name    value
   * xx         xx      12
   * --------------------------------
   */
  Line () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.y == null ? 2 : this.config.y,
      p5 = this.config.order == null ? 0 : this.config.order;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p5 != 0) rows.sort((a, b) => p5 == 1 ? (Number(a[p4]) - Number(b[p4])) : (Number(b[p4]) - Number(a[p4])))
    let ss = []; // series
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ss.find(d => d.name == r[p2]);
      else sd = ss[0];
      let sdr = { y: Number(r[p4]) };
      if (p3 != -1) sdr.name = r[p3];
      if (sd) {
        sd.data.push(sdr);
      } else {
        let ssr = { data: [sdr] };
        if (p2 != -1) ssr.name = r[p2];
        ss.push(ssr);
      }
    }
    let ret = {
      chart: { type: 'line' },
      tooltip: { headerFormat: '', pointFormat: '{point.name}: {point.y:.2f}' },
      xAxis: { type: 'category' },
      series: ss
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * ROC折线图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    x       x轴          2
   *    y       y轴          3
   *    order   排序方式      0      (按x轴排序: 0:不排序,1:升序,-1:降序)
   * --------------------------------
   * group    name     x     y
   * xx         xx     12   12
   * --------------------------------
   */
  Line_ROC () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.x == null ? 2 : this.config.x,
      p5 = this.config.y == null ? 3 : this.config.y,
      p6 = this.config.order == null ? 0 : this.config.order;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p6 != 0) {
      rows.sort((a, b) => p6 == 1 ? (Number(a[p4]) - Number(b[p4])) : (Number(b[p4]) - Number(a[p4])));
      rows.sort((a, b) => p6 == 1 ? (Number(a[p5]) - Number(b[p5])) : (Number(b[p5]) - Number(a[p5])));
    }
    let ss = []; // series
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ss.find(d => d.name == r[p2]);
      else sd = ss[0];
      let sdr = { x: Number(r[p4]), y: Number(r[p5]) };
      if (p3 != -1) sdr.name = r[p3];
      if (sd) {
        sd.data.push(sdr);
      } else {
        let ssr = { data: [sdr] };
        if (p2 != -1) ssr.name = r[p2];
        ss.push(ssr);
      }
    }
    // TODO 这里highcharts好像有bug,yAxis指定了minPadding无效,需要使用min来控制y轴的偏移
    let ret = {
      chart: { type: 'line', plotBorderColor: '#00000066', plotBorderWidth: 1 },
      xAxis: { lineWidth: 0, startOnTick: false, minPadding: 0.05, endOnTick: false, maxPadding: 0.05, tickPositions: [0, 0.2, 0.4, 0.6, 0.8, 1] },
      yAxis: { lineWidth: 0, startOnTick: false, minPadding: 0.05, endOnTick: false, maxPadding: 0.05, min: -0.05, tickPositions: [0, 0.2, 0.4, 0.6, 0.8, 1] },
      series: ss
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 直方图
   * 参数：
   *    title   是否有标题行   true
   *    y       y轴          0
   * --------------------------------
   * y
   * 123
   * --------------------------------
   */
  Histogram () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.y == null ? 0 : this.config.y;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p2) rows = rows.slice(0, p2);
    let sd = []; // series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd.push(Number(r[p2]));
    }
    let ret = {
      chart: { type: 'histogram' },
      legend: { enabled: false },
      tooltip: { headerFormat: '', pointFormat: '{point.y:.2f}' },
      xAxis: { title: { text: 'Values' }, labels: { enabled: false }, tickWidth: 0 },
      series: [{ data: sd }]
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 热图: 第一行必须为标题行， 第一行中除了第一列，剩余列为x轴显示值
   * TODO 这个数据应该再次进行加工： 一共3列： x  y  value
   * --------------------------------
   * yname   x{1...n}
   * xx      12
   * --------------------------------
   */
  Heatmap () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let rows = this.data.slice(1);
    let xc = [], yc = [], sd = []; // xAxis.categories, yAxis.categories, series.data
    xc = this.data[0].slice(1);
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let y = yc.length;
      yc.push(r[0]);
      for (let m = 1, n = r.length; m < n; m++) {
        sd.push([m - 1, y, Number(r[m])])
      }
    }
    let ret = {
      chart: { type: 'heatmap' },
      tooltip: { headerFormat: '', pointFormatter: function () { return `${this.series.yAxis.categories[this.y]}: ${this.value.toFixed(2)}` } },
      colorAxis: { stops: [[0, '#0000FF'], [0.5, '#FFFFFF'], [1, '#FF0000']] },
      plotOptions: { series: { dataLabels: { format: '{point.value:.2f}' } } },
      yAxis: { categories: yc, tickWidth: 0, lineWidth: 0, labels: { step: 1, style: { textOverflow: 'none', whiteSpace: 'nowrap' } } },
      xAxis: { categories: xc, tickWidth: 0, lineWidth: 0 },
      series: [{ data: sd }]
    }
    Utility.deepMerge(this.option, ret);
  }
  Heatmap_Cluster () { this.Heatmap() }

  /**
   * 柱形误差图
   * 参数：
   *    title   是否有标题行   true
   *    name    名称列        0
   *    y       y轴           1
   *    low     误差最小值     2
   *    high    误差最大值     3
   * --------------------------------
   * name    y      low    high
   * xx     12      10     20
   * --------------------------------
   */
  ErrorBar () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.name == null ? 0 : this.config.name,
      p3 = this.config.y == null ? 1 : this.config.y,
      p4 = this.config.low == null ? 2 : this.config.low,
      p5 = this.config.high == null ? 3 : this.config.high;
    let rows = p1 ? this.data.slice(1) : this.data;
    let sd1 = [], sd2 = [], cs = []; // series[0].data,  series[1].data, categories
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd1.push(Number(r[p3]));
      sd2.push([Number(r[p4]), Number(r[p5])]);
      cs.push(r[p2]);
    }
    let ret = {
      xAxis: { categories: cs },
      legend: { enabled: false },
      tooltip: { shared: true },
      series: [{ name: 'Value', type: 'column', data: sd1 }, { name: 'Error', type: 'errorbar', color: '#00000066', data: sd2 }]
    }
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 折线误差图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    y       y轴          2
   *    low     误差最小值     3
   *    high    误差最大值     4
   * --------------------------------
   * group    name    y      low    high
   * xx       xx     12      10     20
   * --------------------------------
   */
  ErrorLine () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.y == null ? 2 : this.config.y,
      p5 = this.config.low == null ? 3 : this.config.low,
      p6 = this.config.high == null ? 4 : this.config.high;
    let rows = p1 ? this.data.slice(1) : this.data;
    let ss = [], cs = [];
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ss.find(d => d.name == r[p2]);
      else sd = ss[0];
      let sdr = { y: Number(r[p4]), low: Number(r[p5]), high: Number(r[p6]) };
      if (p3 != -1) {
        if (cs.indexOf(r[p3]) == -1) cs.push(r[p3]);
      }
      if (sd) {
        sd.data.push(sdr);
      } else {
        sd = { type: 'line', data: [sdr] };
        if (p2 != -1) sd.name = r[p2];
        ss.push(sd);
      }
    }
    for (let i = 0; i < ss.length; i++) {
      let sd = ss[i].data;
      let nsd = [], ebsData = [];
      sd.forEach(sdi => {
        nsd.push(sdi.y);
        ebsData.push([sdi.low, sdi.high]);
      })
      ss[i].data = nsd;
      ss.splice(i + 1, 0, { name: ss[i].name, type: 'errorbar', color: '#00000066', data: ebsData });
      i++;
    }
    let ret = {
      xAxis: { categories: cs },
      tooltip: { shared: true, valueDecimals: 2 },
      series: ss
    }
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 和弦图
   * 参数：
   *    title   是否有标题行   true
   *    from    from列        0
   *    to      to列          1
   *    weight  值            2
   * --------------------------------
   * from    to    weight
   * aa      bb     12
   * --------------------------------
   */
  Dependencywheel () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.from == null ? 0 : this.config.from,
      p3 = this.config.to == null ? 1 : this.config.to,
      p4 = this.config.weight == null ? 2 : this.config.weight;
    let rows = p1 ? this.data.slice(1) : this.data;
    let sd = []; // series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd.push([r[p2], r[p3], Number(r[p4])])
    }
    let ret = {
      chart: { type: 'dependencywheel' },
      tooltip: { headerFormat: '' },
      series: [{ keys: ['from', 'to', 'weight'], data: sd }]
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 气泡图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    x       x轴          2
   *    y       y轴          3
   *    z       气泡大小      4
   *    topX    前x行         null
   * --------------------------------
   * group   name  x	  y    z
   * A     	 a1    16	  16	  22
   * --------------------------------
   */
  Bubble () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.x == null ? 2 : this.config.x,
      p5 = this.config.y == null ? 3 : this.config.y,
      p6 = this.config.z == null ? 4 : this.config.z,
      p7 = this.config.topX;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p7) rows = rows.slice(0, p7);
    let ss = []; // series
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ss.find(t => t.name == r[p2]);
      else sd = ss[0];
      let sdr = { x: Number(r[p4]), y: Number(r[p5]), z: Number(r[p6]), _sn: i };
      if (p3 != -1) sdr.name = r[p3];
      if (sd) {
        sd.data.push(sdr);
      } else {
        let sr = { data: [sdr] };
        if (p2 != -1) sr.name = r[p2];
        ss.push(sr);
      }
    }
    let ret = {
      chart: { type: 'bubble' },
      // legend: { enabled: false },
      tooltip: { headerFormat: '', pointFormat: '{point.name}: {point.z}' },
      plotOptions: { series: { dataLabels: { format: '{key}', crop: false, allowOverlap: true, overflow: 'none' } } },
      yAxis: { gridLineWidth: 0, tickWidth: 1, lineWidth: 1 },
      series: ss
    };
    Utility.deepMerge(this.option, ret);
  }
  Bubble_GO () { this.Bubble() }
  Bubble_KEGG () { this.Bubble() }

  /**
   * 箱线图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    low     下限          2
   *    q1      下四分位      3
   *    median  中位数        4
   *    q3      上四分位      5
   *    high    上限          6
   *    scatter 异常点        7
   * --------------------------------
   * 代谢物    样品    low    q1    median    q3    high    scatter
   * xx       xx      1      2     3        4      3     xx,12;xx,22;
   */
  Boxplot () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.low == null ? 2 : this.config.low,
      p5 = this.config.q1 == null ? 3 : this.config.q1,
      p6 = this.config.median == null ? 4 : this.config.median,
      p7 = this.config.q3 == null ? 5 : this.config.q3,
      p8 = this.config.high == null ? 6 : this.config.high,
      p9 = this.config.scatter == null ? 7 : this.config.scatter;
    let rows = p1 ? this.data.slice(1) : this.data;
    let series = [{ data: [] }, { data: [], type: 'scatter' }];
    for (let i = 0; i < rows.length; i++) {
      let r = rows[i], g = r[p2];
      let sdr = { group: g, name: r[p3], low: Number(r[p4]), q1: Number(r[p5]), median: Number(r[p6]), q3: Number(r[p7]), high: Number(r[p8]) };
      series[0].data.push(sdr);
      let sc = r[p9];
      if (sc) {
        let sci = series[0].data.length - 1;
        let sps = sc.split(';');
        let spd = [];
        sps.forEach(spsi => {
          let sppi = spsi.split(',');
          spd.push({ name: sppi[0], x: sci, y: Number(sppi[1]) });
        })
        series[1].data.push(...spd);
      }
    }
    let ret = {
      chart: { type: 'boxplot' },
      legend: { enabled: false },
      tooltip: { headerFormat: '', pointFormat: '{point.name}<br/>low:{point.low:.2f}<br/>q1:{point.q1:.2f}<br/>median:{point.median:.2f}<br/>q3:{point.q3:.2f}<br/>high:{point.high:.2f}' },
      series: series,
      xAxis: { type: 'category' },
      plotOptions: {
        series: { stickyTracking: false, },
        scatter: { tooltip: { headerFormat: '', pointFormat: '{point.name}: {point.y:.2f}' } }
      }
    };
    Utility.deepMerge(this.option, ret);
  }
  /**
   * 多组箱线图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    low     下限          2
   *    q1      下四分位      3
   *    median  中位数        4
   *    q3      上四分位      5
   *    high    上限          6
   *    scatter 异常点        7
   * --------------------------------
   * 代谢物    样品    low    q1    median    q3    high    scatter
   * xx       xx      1      2     3        4      3     xx,12;xx,22;
   */
  Boxplot_Multi () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.low == null ? 2 : this.config.low,
      p5 = this.config.q1 == null ? 3 : this.config.q1,
      p6 = this.config.median == null ? 4 : this.config.median,
      p7 = this.config.q3 == null ? 5 : this.config.q3,
      p8 = this.config.high == null ? 6 : this.config.high,
      p9 = this.config.scatter == null ? 7 : this.config.scatter;
    let rows = p1 ? this.data.slice(1) : this.data;
    let ret = []; // 多组箱子数据
    for (let i = 0; i < rows.length; i++) {
      let r = rows[i];
      let g = r[p2];
      let ser = ret.find(gr => gr[0].name == g);
      let sdr = { name: r[p3], low: Number(r[p4]), q1: Number(r[p5]), median: Number(r[p6]), q3: Number(r[p7]), high: Number(r[p8]) };
      if (ser) {
        ser[0].data.push(sdr);
      } else {
        ser = [{ name: g, data: [sdr] }];
        ret.push(ser);
      }
      let sc = r[p9];
      if (sc) {
        let sci = ser[0].data.length - 1;
        let sct = ser.find(serr => serr.type == 'scatter');
        let sps = sc.split(';');
        let spd = [];
        sps.forEach(spsi => {
          let sppi = spsi.split(',');
          spd.push({ name: sppi[0], x: sci, y: Number(sppi[1]) });
        })
        if (sct) {
          sct.data.push(...spd);
        } else {
          ser.push({ type: 'scatter', data: spd });
        }
      }
    }
    this.option = ret;
  }

  /**
   * 柱形图
   * 参数：
   *    title   是否有标题行   true
   *    name    名称列        0
   *    y       y轴          1
   *    topX    前x行         null
   * --------------------------------
   * name    value
   * xx       123
   * --------------------------------
   */
  Bar () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.name == null ? 0 : this.config.name,
      p3 = this.config.y == null ? 1 : this.config.y,
      p4 = this.config.topX;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p4) rows = rows.slice(0, p4);
    let xc = [], sd = []; // xAxis.categories, series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      xc.push(r[p2]);
      sd.push(Number(r[p3]));
    }
    let ret = {
      chart: { type: 'column' },
      legend: { enabled: false },
      tooltip: { headerFormat: '', pointFormat: '{point.category}: {point.y:.2f}' },
      xAxis: { categories: xc }, series: [{ data: sd }]
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 分组柱形图
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    名称列        1
   *    y       y轴          2
   *    topX    前x行         null
   * --------------------------------
   * group  name    value
   * xx      xx      123
   * --------------------------------
   */
  Bar_Group () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.y == null ? 2 : this.config.y,
      p5 = this.config.topX;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p5) rows = rows.slice(0, p5);
    rows.sort((a, b) => a[p2].localeCompare(b[p2]));
    let xc = [], sd = []; // xAxis.categories, series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      xc.push(r[p3]);
      sd.push({ y: Number(r[p4]), _group: r[p2] });
    }
    let ret = {
      chart: { type: 'column' },
      plotOptions: { series: { pointPadding: 0.05, groupPadding: 0 } },
      tooltip: { headerFormat: '', pointFormat: '{point.category}: {point.y:.2f}' },
      xAxis: { categories: xc, tickmarkPlacement: 'on' }, series: [{ data: sd }]
    };
    Utility.deepMerge(this.option, ret);
  }

  /**
   * 柱形图堆叠: 
   * 参数：
   *    title   是否有标题行   true
   *    group   分组列        0
   *    name    分组列        1
   *    y       y轴          2
   *    topX    前x行        null
   *    order   排序方式      0      (按y轴排序: 0:不排序,1:升序,-1:降序)
   * --------------------------------
   * group    name    y
   * xx       xx      12
   * --------------------------------
   */
  Bar_Stack () {
    if (!this.data || !this.data.length) {
      console.warn('npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.group == null ? 0 : this.config.group,
      p3 = this.config.name == null ? 1 : this.config.name,
      p4 = this.config.y == null ? 2 : this.config.y,
      p5 = this.config.order == null ? 0 : this.config.order;
    let rows = p1 ? this.data.slice(1) : this.data;
    if (p5 != 0) {
      rows.sort((a, b) => p5 == 1 ? (Number(a[p4]) - Number(b[p4])) : (Number(b[p4]) - Number(a[p4])))
    }
    let ss = []; // series
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      let sd;
      if (p2 != -1) sd = ss.find(d => d.name == r[p2]);
      else sd = ss[0];
      if (sd) {
        if (p3 != -1) sd.data.push({ name: r[p3], y: Number(r[p4]) });
        else sd.data.push({ y: Number(r[p4]) });
      } else {
        let ssr;
        if (p3 != -1) ssr = { data: [{ name: r[p3], y: Number(r[p4]) }] };
        else ssr = { data: [{ y: Number(r[p4]) }] }
        if (p2 != -1) ssr.name = r[p2];
        ss.push(ssr);
      }
    }
    let ret = {
      chart: { type: 'column' },
      xAxis: { type: 'category' },
      tooltip: { headerFormat: '', pointFormat: '{point.name}: {point.y:.2f}' },
      series: ss
    };
    Utility.deepMerge(this.option, ret);
  }

  Bar_Butterfly () { this.Bar_Stack() }
  Bar_GO () { this.Bar_Stack() }

  /**
   * 哑铃图
   * 参数：
   *    title   是否有标题行   true
   *    name    名称列        0
   *    low     最小值        1
   *    high    最大值        2
   * --------------------------------
   * name        low        value
   * xx          123         22
   * --------------------------------
   */
  Dumbbell () {
    if (!this.data || !this.data.length) {
      console.warn('Dumbbell npe');
      return;
    }
    let
      p1 = this.config.title == false ? false : true,
      p2 = this.config.name == null ? 0 : this.config.name,
      p3 = this.config.low == null ? 1 : this.config.low,
      p4 = this.config.high == null ? 2 : this.config.high;
    let rows = p1 ? this.data.slice(1) : this.data;
    let sd = []; // series.data
    for (let i = 0, l = rows.length; i < l; i++) {
      let r = rows[i];
      sd.push({ name: r[p2], low: Number(r[p3]), high: Number(r[p4]) });
    }
    let ret = {
      chart: { type: 'dumbbell', inverted: true },
      legend: { enabled: false },
      xAxis: { type: 'category' }, series: [{ data: sd }]
    };
    Utility.deepMerge(this.option, ret);
  }

}
export default ChartOptionBuilder;